<template>
  <div id="content-container">
    <ApplyIndex :condition="{ approving: true }"></ApplyIndex>
  </div>
</template>

<script>
import ApplyIndex from './index.vue'

export default {
  components: {
    ApplyIndex,
  },
}
</script>